/**
 * Performed-work-only filtering for historical output (History detail, the
 * post-workout Summary, and the PDF/report).
 *
 * A session materialises every planned set and cardio segment up front, so a
 * finished workout still carries rows the user never did. Historical output
 * represents what was actually performed, and `isCompleted` is the one proof
 * of performance, for sets and cardio segments alike. Deliberately NOT applied
 * to `listSets()`/`listSegments()`: the live workout still needs the
 * unfinished rows. Pure and non-mutating, like the rest of this package.
 */

/** The completed rows of `rows`, in their original order. Works for set-like and segment-like records. */
export function completedRows<T extends { isCompleted: boolean }>(rows: readonly T[]): T[] {
  return rows.filter((row) => row.isCompleted);
}
